var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data && _vm.data.length)?_c('flexible-slider-section',{attrs:{"section":{ title: 'Inne tej marki', data: { products: _vm.data } },"h-tag":false,"loading":_vm.loading}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }